import { render, staticRenderFns } from "./InputScatterplot.vue?vue&type=template&id=06f7366c"
import script from "./InputScatterplot.vue?vue&type=script&lang=js"
export * from "./InputScatterplot.vue?vue&type=script&lang=js"
import style0 from "./InputScatterplot.vue?vue&type=style&index=0&id=06f7366c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports